import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    let route = routerState.root;
    let breadcrumb = '';
    while (route.firstChild) {
      route = route.firstChild;
      if (route.data['breadcrumb']) {
        breadcrumb = route.data['breadcrumb'];
      }
    }
    this.title.setTitle(
      breadcrumb ? `Super Agents - ${breadcrumb}` : 'Super Agents'
    );
  }
}
